import AccountService from './accountServices.js';
import { configureStore } from '../store';
import { TokenSession } from 'urbnTokenLib';
import { scopeTypes } from '../../../core/js/constants';

class Service {
    constructor(AccountService) {
        // Nothing to pass here

        this.getState = configureStore().getState;
        this.localePath = this.getState().core.constants.siteId;
        this.a15URLs = this.getState().core.constants.urls;
        this.store = configureStore();
    }

    /**
     * Get Cookie By Name
     * Retrieves a cookie by name
     * c_name: name of the cookie you want to find the value for
     */
    getCookieByName(c_name) {
        if (document.cookie.length > 0) {
            let c_end;
            let c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) {
                    c_end = document.cookie.length;
                }
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    }

    /**
     * Set Cookie
     * Sets or creates a cookie
     * name: the name of the cookie you want to set or create
     * value: the value you want to store in the above-named cookie
     * secs: the expiration time for the cookie, in seconds
     */
    setCookie(name,value,secs) {
        console.log('services: setCookie');

        let expires;
        if (secs) {
            let date = Date.now() + (secs * 1000);
            date = date.toGMTString();
            expires = "; expires=" + date;
        }
        else {
            expires = '';
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    /**
     * @POST Get authed session
     * @param {Object} params
     * 	{String} email
     * 	{String} password
     */

    getSession(model, viewModel, controller, selector) {
        console.log("service: getSession");

        const tokenSession = new TokenSession.fromCookie();

        return new Promise(function(resolve, reject){
            if(tokenSession !== ''){
                let tokenObject = {
                    data: {
                        session: tokenSession
                    },
                    status: 200
                };
                resolve(tokenObject);
            }
            else{
                console.log('getAuthToken FAIL!');
                reject({status: 401,type:'serviceError',data:{}});
            }
        });
    }

    /**
     * @POST Get Auth Token
     * Retrieves a token for user after a password is updated
     * @param {Object} params
     * 	{String} email
     * 	{String} password
     */
    authWithNewPassword(params, model, viewModel, controller, selector) {
        console.log("service: authWithNewPassword");

        let options = {
            method:'POST',
            path: `${this.a15URLs.token}/${this.localePath}/auth`,
            entity: params,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * Broadcasts new token to trigger Angular login success event
     * @param {Object} results
     *	{Boolean}
     * 	{Object}
     *		{Object} data
     *			{String} authToken
     *			{Number} expiresIn
     *			{String} reauthToken
     *			{String} scope
     *			{String} tracer
     *			{Number} ttl
     *		{Number} status
     */
    triggerLoginSuccess(results) {
        // let modalScope = angular.element('#urbn-login-dialog').scope();
        //
        // return modalScope.$broadcast('urbn-login:success', null, results, null);
    }

    /**
     * @PUT Re-Auth Token
     * Refresh auth token
     */

    forceReauth(params, model, viewModel, controller, selector) {
        console.log("forceReauth");

        let options = {
            method: 'PUT',
            path: `${this.a15URLs.token}/${this.localePath}/auth`,
            entity: params,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        console.log('call httpRequest please');
        return AccountService.httpRequest(options);
    }

    /**
     * @GET Get Profile
     * Get customer profile
     */
    getProfile(session, model, viewModel, controller, selector) {
        console.log("services: getProfile");

        let options = {
            method: 'GET',
            params: {},
            path: `${this.a15URLs.profile}/${this.localePath}/me`,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return new Promise((resolve, reject) => {
            resolve(AccountService.httpRequest(options));
        });
    }

    /**
     * @PUT Update Profile
     * Update customer profile
     * @param {Object} params
     * 	{Object} name
     * 		{String} middle
     *		{String} prefix
     *		{String} last
     *		{String} suffix
     *		{String} first
     * 	{String} gender
     * 	{Number} dateOfBirth
     * 	{Number} defaultPaymentId
     * 	{String} emailAddress
     * 	{Number} defaultShippingAddressId
     *	{String} sterlingId
     */

    updateProfile(params,session, model, viewModel, controller, selector) {
        console.log('services: updateProfile');
        console.log(params);
        let options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me`,
            entity: params,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return new Promise((resolve, reject) => {
            resolve(AccountService.httpRequest(options));
        });
    }

    /**
     * @PATCH Update Profile
     * Update customer first & last name
     * @param {Object} params
     * @param {Object} params.name
     * @param {string} params.name.last
     * @param {string} params.name.first
     * @param {string} params.gender
     * @param {Object} params.dateOfBirth
     * @param {number} params.dateOfBirth.day
     * @param {number} params.dateOfBirth.month
     * @param {number} params.dateOfBirth.year
     * @param {string} params.defaultPaymentId
     * @param {string} params.emailAddress
     * @param {Object} params.employee
     * @param {string} params.employee.employeeId
     * @param {string} params.defaultShippingAddressId
     * @param {string} params.defaultWishlistAddressId
     * @param {Object} params.student
     * @param {boolean} params.student.college
     * @param {number} params.student.graduation
     * @returns {promise}
     */
    patchFirstLastName(params, session, model, viewModel, controller, selector) {
        console.log("services: patchFirstLastName");
        let options = {
            method: 'PATCH',
            path: `${this.a15URLs.profile}/${this.localePath}/me`,
            entity: [
                {
                    "op": "replace",
                    "path": "\/name\/last",
                    "value": params.name.last
                },
                {
                    "op": "replace",
                    "path": "\/name\/first",
                    "value": params.name.first
                }],
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        if (this.store.getState().core.constants.accountOptions.showUsername) {
            const userNameEntity = {
                    "op": "replace",
                    "path": "loyaltyUserName",
                    "value": params.loyaltyUserName
                };

            options.entity.push(userNameEntity)
        };

       return AccountService.httpRequest(options);
    }

    /**
     * Send updated email for Cheetah Mail
     */
    updateEmail(params, session, model, viewModel, controller, selector) {
        console.log('services: updateEmail params: ' + params);
        let options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/credentials/username`,
            entity: {'username':params},
            session: session,
            contentType: 'application/json',
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @PUT Update Profile
     * Update customer profile
     * @param {Object} params
     * 	{Object} name
     * 		{String} middle
     *		{String} prefix
     *		{String} last
     *		{String} suffix
     *		{String} first
     * 	{String} gender
     * 	{Number} dateOfBirth
     * 	{Number} defaultPaymentId
     * 	{String} emailAddress
     * 	{Number} defaultShippingAddressId
     *	{String} sterlingId
     */
    updatePassword(params, session, model, viewModel, controller, selector) {
        let options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/credentials/password`,
            entity: params,
            session: session,
            contentType: 'application/json',
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };
        console.log('password service');
        console.log(params);

        return AccountService.httpRequest(options);
    }

    /**
     * @GET Get Preferences
     * Get customer preferences
     */
    getPreferences(session, model, viewModel, controller, selector) {
        let options = {
            method: 'GET',
            params: {},
            path: `${this.a15URLs.profile}/${this.localePath}/me/preferences`,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @POST Create Preferences
     * Create customer preferences
     */
    createPreferences(params, session, model, viewModel, controller, selector) {
        let options = {
            method: 'POST',
            path: `${this.a15URLs.profile}/${this.localePath}/me/preferences`,
            session: session,
            entity: params,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @PUT Update Preferences
     * Update customer preferences
     */
    updatePreferences(params, session, model, viewModel, controller, selector) {
        let options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/preferences`,
            session: session,
            entity: params,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @PUT Update Preferences Global
     * Update customer global preferences
     */
    updatePreferencesGlobal(params, session, model, viewModel, controller, selector) {
        let options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/preferences/global`,
            session: session,
            entity: params,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        if (model.initialized.preferences.postNeeded) {
            options.path = `${this.a15URLs.profile}/${this.localePath}/me/preferences`;
            options.method = 'POST';
            options.entity = {"global": params};
        }
        return AccountService.httpRequest(options);
    }

    /**
     * @PUT Update Preferences Web
     * Update customer web preferences
     */
    updatePreferencesWeb(params, session, model, viewModel, controller, selector) {
        let options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/preferences/web`,
            session: session,
            entity: params,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @PUT Update Preferences Social Media
     * Update customer social media preferences
     */
    updatePreferencesSocialMedia(params, session, model, viewModel, controller, selector) {
        let options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/preferences/socialMedia`,
            session: session,
            entity: params.socialMedia,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        //TODO- abstract this out of social media specifically, for other preference puts that require a post first
        if (model.initialized.preferences.postNeeded) {
            options.path = `${this.a15URLs.profile}/${this.localePath}/me/preferences`;
            options.method = 'POST';
            options.entity = params;
        }
        return AccountService.httpRequest(options);
    }

    /**
     * @PUT Update Preferences Mobile App
     * Update customer mobile app preferences
     */
    updatePreferencesMobileApp(params, session, model, viewModel, controller, selector) {
        let options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/preferences/mobileApp`,
            session: session,
            entity: params,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @GET Get Addresses
     * Get list of addresses
     */
    getAddresses(session, model, viewModel, controller, selector) {
        console.log("services: getAddress");

        let options = {
            method: 'GET',
            path: `${this.a15URLs.profile}/${this.localePath}/me/addresses`,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    getPayments(session, model, viewModel, controller, selector) {
        console.log("services: getPayments");

        let options = {
            method: 'GET',
            path: `${this.a15URLs.profile}/${this.localePath}/me/payments`,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @GET Get Addresses
     * Get a specific address
     * @param {String} id
     */
    getAddress(id, model, viewModel, controller, selector) {
        console.log("services: getAddress");

        let options = {
            method: 'GET',
            path: `${this.a15URLs.profile}/${this.localePath}/me/addresses/${id}`,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @POST Create Address
     * Add a profile address
     * @param {Object} params
     * 	{String} profileId
     * 	{Object} address
     * 	 {String} city
     *	 {String} poBox
     *	{Object} name
     *	 {String} last
     *	 {String} first
     *	{String} address1
     *	{String} verificationStatus
     *	{Boolean} masked
     *	{String} country
     *	{String} postalCode
     *	{String} region
     */
    createAddress(params, session, model, viewModel, controller, selector) {
        let options = {
            method: 'POST',
            entity: params,
            path: `${this.a15URLs.profile}/${this.localePath}/me/addresses`,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    submitNewPayment(params, session, model, viewModel, controller, selector) {
        const options = {
            method: 'POST',
            entity: params,
            path: `${this.a15URLs.profile}/${this.localePath}/me/payments`,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @DELETE Delete Addresses
     * Delete an address
     * @param {String} id
     */
    deleteAddress(params, session, model, viewModel, controller, selector) {
        console.log('ADDRESSID');
        console.log(params);
        let id = params;
        let options = {
            method: 'delete', // This lower case delete is needed for ie11 unfortunately.
            path: `${this.a15URLs.profile}/${this.localePath}/me/addresses/${id}`,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @PUT Update Address
     * Update an address
     * @param {String} id
     * @param {Object} params
     *	{String} profileId
     *	{Object} address
     * 		{String} city
     *		{String} poBox
     *		{Object} name
     *			{String} last
     *			{String} first
     *		{String} address1
     *		{String} verificationStatus
     *		{Boolean} masked
     *		{String} country
     *		{String} postalCode
     *		{String} region
     */
    updateAddress(params, session, model, viewModel, controller, selector) {
        let id = params.id;
        params.id = undefined;
        let options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/addresses/${id}`,
            session: session,
            entity: params,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @GET Get Payments
     * Get list of payments
     * @param {String} id
     */
    getPayment(id, model, viewModel, controller, selector) {
        var options = {
            method: 'GET',
            path: `${this.a15URLs.profile}/${this.localePath}/me/payments/${id}`,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        AccountService.httpRequest(options)
            .then(
                function(response) {
                    return response;
                },
                function(error) {
                    console.error('Something went wrong', error);
                }
            );
    }

    /**
     * @DELETE Delete Payment
     * Delete a payment
     * @param {String} id
     */

    deletePayment(params, session, model, viewModel, controller, selector) {
        let id = params.id;
        let options = {
            method: 'delete', // This lower case delete is needed for ie11 unfortunately.
            path: `${this.a15URLs.profile}/${this.localePath}/me/payments/${id}`,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @PUT Update Payment
     * Update an address
     * @param {String} id
     * @param {Object} params
     *	{String} paymentType
     *	{Object} creditCardDetail
     * 		{String} expirationMonth
     *		{String} expirationYear
     *		{String} addressId
     *	{String} profileId
     *	{Boolean} visible
     *	{String} cartId
     */

    updatePayment(params, session, model, viewModel, controller, selector) {
        console.log('updating payment');
        let id = params.id;

        let options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/payments/${id}`,
            session: session,
            entity: params,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @GET Get Email Subscription
     * Get the current authenticated user's email subscriptions
     * @param {String} email (optional)
     */

    getEmailSubscription(session, model, viewModel, controller, selector) {
        let email = model.get('emailAddress');

        var options = {
            method: 'GET',
            path: `${this.a15URLs.profile}/${this.localePath}/me/subscriptions/email`,
            session: session,
            email: model.get('profile').emailAddress,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @POST Create Email Subscription
     * Create an email subscription
     * @param {Object} params
     *	{String} currentEmailId
     *	{String} action
     *	{String} gender
     *	{String} listName
     *	{String} source
     */

    createEmailSubscription(params, model, viewModel, controller, selector) {
        var options = {
            method:'POST',
            path: `${this.a15URLs.profile}/${this.localePath}/me/subscriptions/email${$.param(params)}`,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        AccountService.httpRequest(options)
            .then(
                function(response) {
                    return response;
                },
                function(error) {
                    console.error('Something went wrong', error);
                }
            );
    }

    /**
     * @PUT Update Email Subscription
     * Update an email subscription
     * @param {Object} params
     *	{String} currentEmailId
     *	{String} action
     *	{String} gender
     *	{String} listName
     *	{String} source
     */

    updateSubscriptionsEmail(params,session, model, viewModel, controller, selector) {
        console.log('params');
        console.log(params);
        var options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/subscriptions/email`,
            entity: params,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @GET Get Loyalty Subscription
     * Get the current authenticated user's loyalty subscriptions
     */

    getLoyaltySubscription(session, model, viewModel, controller, selector) {
        var options = {
            method: 'GET',
            path: `${this.a15URLs.profile}/${this.localePath}/me/subscriptions/loyalty`,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        AccountService.httpRequest(options)
            .then(
                function(response) {
                    return response;
                },
                function(error) {
                    console.error('Something went wrong', error);
                }
            );
    }

    /**
     * @POST Create Loyalty Subscription
     * Create a loyalty subscription
     * @param {Object} params
     *	{String} loyaltyId
     *	{String} channelId
     *	{Number} loyaltyDate
     *	{String} channel
     */

    createLoyaltySubscription(model, session, viewModel, controller, selector) {
        var options = {
            method: 'POST',
            path: `${this.a15URLs.profile}/${this.localePath}/me/subscriptions/loyalty`,
            entity: {
                "channelId": "WEB",
                "loyaltyDate": 0,
                "channel": "WEB"
            },
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * @PUT Update Loyalty Subscription
     * Update an email subscription
     * @param {Object} params
     *	{String} loyaltyId
     *	{String} channelId
     *	{Number} loyaltyDate
     *	{String} channel
     */

    updateLoyaltySubscription(session, params, model, viewModel, controller, selector) {
        var options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/subscriptions/loyalty${$.param(params)}`,
            entity: params,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        AccountService.httpRequest(options)
            .then(
                function(response) {
                    return response;
                },
                function(error) {
                    console.error('Something went wrong', error);
                }
            );
    }

    /**
     * @GET Get Push Notification
     * Get the current authenticated user's push notification subscription
     */
    getPushNotification(model, viewModel, controller, selector) {
        var options = {
            method: 'GET',
            path: `${this.a15URLs.profile}/${this.localePath}/me/subscriptions/push_notification`,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        AccountService.httpRequest(options)
            .then(
                function(response) {
                    return response;
                },
                function(error) {
                    console.error('Something went wrong', error);
                }
            );
    }

    /**
     * @POST Create Push Notification Subscription
     * Create a push notification subscription
     * @param {Object} params
     *	{String} session
     *	{Array} subscriptionCategories
     *	{String} tokenType
     *	{Boolean} pushAllowed
     */
    createPushNotification(params, model, viewModel, controller, selector) {
        var options = {
            method: 'POST',
            path: `${this.a15URLs.profile}/${this.localePath}/me/subscriptions/push_notification${$.param(params)}`,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        AccountService.httpRequest(options)
            .then(
                function(response) {
                    return response;
                },
                function(error) {
                    console.error('Something went wrong', error);
                }
            );
    }

    /**
     * @PUT Update Push Notification Subscription
     * Update a push notification subscription
     * @param {Object} params
     *	{Array} subscriptionCategories
     *	{Boolean} pushAllowed
     */
    updatePushNotification(params, model, viewModel, controller, selector) {
        var options = {
            method: 'PUT',
            path: `${this.a15URLs.profile}/${this.localePath}/me/subscriptions/push_notification${$.param(params)}`,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        AccountService.httpRequest(options)
            .then(
                function(response) {
                    return response;
                },
                function(error) {
                    console.error('Something went wrong', error);
                }
            );
    }

    getSubscriptions(session, model, viewModel, controller, selector){
        if (typeof viewModel.viewStates !== 'undefined' && typeof viewModel.viewStates.callSubscriptions !== 'undefined' && viewModel.viewStates.callSubscriptions) {
            let options = {
                method: 'GET',
                params: {},
                path: `${this.a15URLs.profile}/${this.localePath}/me/subscriptions`,
                session: session,
                store: this.store,
                model: model,
                viewModel: viewModel,
                controller: controller,
                selector: selector,
                scope: scopeTypes.AUTHORIZED
            };

            return AccountService.httpRequest(options);
        }

        return;
    }

    getEmployeeStatus(session, model, viewModel, controller, selector){
        let options = {
            method: 'GET',
            params: {},
            path: `${this.a15URLs.profile}/${this.localePath}/me/employees`,
            session: session,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * Get mislConfig from store
     * @return {object} Object containing brand specific API key and brand id
     */
    getMislConfig() {
        return {
            apiKey: this.store.getState().core.constants.mislConfig.misl_urbn_key,
            brandId: this.store.getState().core.constants.mislConfig.brandId
        };
    }

    /**
     * Get list of stores from MISL based on coordinates
     * @param  {object} coords Object containing latitude and longitude
     * @return {object}        A promise to be resolved or rejected
     */
    getStores(coords, model, viewModel, controller, selector){
        let options = {
            method:'GET',
            path: `${this.store.getState().core.constants.urls.misl}/stores/search?urbn_key=${this.getMislConfig().apiKey}&lat=${coords.lat}&lng=${coords.lng}&brandId=${this.getMislConfig().brandId}&distance=50`,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * Get list of stores from MISL based on state
     * @param  {string} state The state to search for
     * @return {object}       A promise to be resolved or rejected
     */
    getStoresState(state, model, viewModel, controller, selector){
        let options = {
            method:'GET',
            path: `${this.store.getState().core.constants.urls.misl}/stores/search?urbn_key=${this.getMislConfig().apiKey}&state=${state}&brandId=${this.getMislConfig().brandId}`,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }

    /**
     * Get store data from MISL for a single store
     * @param  {string} storeId The store ID to search for
     * @return {object}         A promise to be resolved or rejected
     */
    getAllStores(queryParam, model, viewModel, controller, selector){
        let options = {
            method:'GET',
            path: `${this.store.getState().core.constants.urls.misl}/stores/search?urbn_key=${this.getMislConfig().apiKey}&brandId=${this.getMislConfig().brandId}&storeNumber=${queryParam}`,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };
        return AccountService.httpRequest(options);
    }

    /**
     * Get registry info for the currently auth'd customer
     * @param  {string} session    The current user's session
     * @param  {object} model      The current data model
     * @param  {object} viewModel  The current viewModel
     * @param  {object} controller The current controller
     * @param  {object} selector   The element that triggered the call
     * @return {object}            A promise to be resolved or rejected
     */
    getRegistryInfo(session, model, viewModel, controller, selector) {
        console.log("services: getRegistryInfo");
        const state = this.getState();
        const isRegistryEnabled = _.get(state, 'core.constants.accountOptions.is_registry_enabled', false);
        const isSiteOutsideNorthAmerica = _.get(state, 'core.isSiteOutsideNorthAmerica', false);
        const shouldRequestRegistry = isRegistryEnabled && !isSiteOutsideNorthAmerica;

        if (shouldRequestRegistry) {
            const params = {
                'email': model.profile.emailAddress
            };

            // update this once registry path gets into core
            const registryPath = '/api/registry/v1';

            const options = {
                method: 'GET',
                params: params,
                path: `${registryPath}/${this.localePath}/search`,
                session: session,
                store: this.store,
                model: model,
                viewModel: viewModel,
                controller: controller,
                selector: selector,
                scope: scopeTypes.AUTHORIZED,
                entity: params
            };

            return new Promise((resolve, reject) => {
                resolve(AccountService.httpRequest(options));
            });
        } else {
            return new Promise((resolve, reject) => {
                resolve({});
            });
        }
    }

    /**
     * Get pxp public encryption key
     * @param  {object} model      The current data model
     * @param  {object} viewModel  The current viewModel
     * @param  {object} controller The current controller
     * @param  {object} selector   The element that triggered the call
     * @return {object}       A promise to be resolved or rejected
     */
    getPxpPublicKey(model, viewModel, controller, selector) {
        const state = this.store.getState();
        const catalog = _.get(state, 'core.constants.urls.catalog');
        const siteId = _.get(state, 'core.constants.siteId');

        const options = {
            method: 'GET',
            path: `${catalog}/${siteId}/configuration/pxp-public-key`,
            store: this.store,
            model: model,
            viewModel: viewModel,
            controller: controller,
            selector: selector,
            scope: scopeTypes.AUTHORIZED
        };

        return AccountService.httpRequest(options);
    }
}

const service = new Service(AccountService);

export default service;
